// extracted by mini-css-extract-plugin
export default {"popup":"ResultPopup_popup__-9QTH","svg-container":"ResultPopup_svg-container__wk16z"};